import { BoxProps, forwardRef } from '@chakra-ui/react';
import Box from '../Box/Box';

export interface DotProps extends BoxProps {
  size: BoxProps['width'];
}

const Dot = forwardRef<DotProps, 'div'>((props, ref) => {
  const { size, ...rest } = props;

  return <Box ref={ref} aria-hidden borderRadius="50%" height={size} width={size} {...rest} />;
});

export default Dot;
